import { render, staticRenderFns } from "./publish.vue?vue&type=template&id=12965e56&scoped=true&"
import script from "./publish.vue?vue&type=script&setup=true&lang=ts&"
export * from "./publish.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./publish.vue?vue&type=style&index=0&id=12965e56&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12965e56",
  null
  
)

export default component.exports